var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudfount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.13 28.509l1.415 1.414-7.865 7.864a.993.993 0 01-.707.293.993.993 0 01-.707-.293l-7.864-7.864 1.414-1.414 6.157 6.157V9.116h2v25.55l6.158-6.157zm-7.157 15.436C12.96 43.945 4 34.985 4 23.973 4 12.96 12.96 4 23.973 4c11.012 0 19.972 8.96 19.972 19.973 0 11.013-8.96 19.972-19.972 19.972zm0-41.945C11.857 2 2 11.857 2 23.973c0 12.115 9.857 21.972 21.973 21.972s21.972-9.857 21.972-21.972C45.945 11.857 36.089 2 23.973 2z",
    fill: "#4D27AA",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudfount);
export default __webpack_public_path__ + "static/media/cloudfount.65e3a0e3d32ddf769ddd1cd872817be4.svg";
export { ForwardRef as ReactComponent };